import {Component, Input} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {AdUnitTagPreviewDialogComponent} from './ad-unit-tag-preview-dialog.component';
import {BridgeAdUnit} from '../../domain/bridge-ad-unit.model';

@Component({
  selector: 'cm-ad-unit-tag-preview-button',
  template: `
    <button mat-icon-button
            color="primary"
            *ngIf="this.bau.adUnitTag"
            (click)="openAdUnitTagPopup()"
            matTooltip="Ad Unit Tag" >
      <i class="far fa-code" aria-hidden="true"></i>
    </button>
  `
})
export class AdUnitTagPreviewButtonComponent {


  @Input()
  public bau: BridgeAdUnit;

  constructor(private matDialog: MatDialog) {
  }

  openAdUnitTagPopup() {
    this.matDialog.open(AdUnitTagPreviewDialogComponent, <MatDialogConfig> {
      data: {
        adUnitName: this.bau.name,
        adUnitTag: this.adjustTag(this.bau),
      },
      width: '700px'
    });
  }

  /**
   * we need to adjust tag in cases where units are native-infeed
   */
  adjustTag(bau: BridgeAdUnit): string {
    if (bau.adUnitTag.includes('native-infeed')) {
      const newTag = `<script type=\"text/javascript\" src=\"https://yummy.consumable.com/${bau.campaignId}/${bau.widgetName}/widget/unit.js\" async></script>`;
      return newTag;
    } else {
      return bau.adUnitTag;
    }
  }
}
